import { render, staticRenderFns } from "./CheckboxView.vue?vue&type=template&id=824a5bd8&"
import script from "./CheckboxView.vue?vue&type=script&lang=js&"
export * from "./CheckboxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports